module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0021.jpg?v=b7b6d64c";